import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[1]};
`;

export const Subtitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    font-family: ${({ theme }) => theme.font.family};
    color: ${({ theme }) => theme.color.black300};
    line-height: 16px;
`;
